import { computed } from 'vue'

function getByPath(obj, path) {
    return path.split('.').reduce((acc, key) => acc?.[key] ?? null, obj)
}

export function useSearch(items, searchFields, queryRef) {
    const isSearching = computed(() => queryRef.value.trim() !== '')

    const results = computed(() => {
        const q = queryRef.value.trim()
        if (!q) return []

        const escaped = q.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
        const regex = new RegExp(`(${escaped})`, 'gi')

        return items.value.filter(item =>
            searchFields.some(path => {
                const val = getByPath(item, path)
                return typeof val === 'string' && val.toLowerCase().includes(q.toLowerCase())
            })
        ).map(item => {
            const highlighted = {}
            searchFields.forEach(path => {
                const val = getByPath(item, path)
                if (typeof val === 'string' && val.toLowerCase().includes(q.toLowerCase())) {
                    highlighted[path] = val.replace(regex, '<em>$1</em>')
                }
            })
            return { ...item, _highlighted: highlighted }
        })
    })

    return { results, isSearching }
}
